import RunScreenerInputContainerFieldsFragment from "components/screener/v2/query/RunScreenerInputContainerFieldsFragment";
import ScreenerIndicatorFieldsFragment from "components/screener/v2/query/ScreenerIndicatorFieldsFragment";
import gql from "graphql-tag";
const RunScreenerInputsQuery = gql`
  query RunScreenerInputs($language: ISO6391LanguageCode) {
    runScreenerInputs(language: $language) {
      objectId
      ...RunScreenerInputContainerFields
      selectedIndicators {
        ...ScreenerIndicatorFields
      }
    }
  }
  ${RunScreenerInputContainerFieldsFragment}
  ${ScreenerIndicatorFieldsFragment}
`;
export default RunScreenerInputsQuery;
